// src/components/homepage/HomePageVision.tsx

import React from 'react';
import { motion } from 'framer-motion';
import { Check, ArrowRight } from 'lucide-react';
import {Button} from '@dopomogai/ui';
import { ConsciousNetworkVisual } from '../../visuals/ConsciousNetworkVisual'; // <-- NEW IMPORT

// ... (Interfaces and props remain the same) ...
interface VisionData {
  headline: string;
  intro: string;
  point1: string;
  point2: string;
  point3: string;
  cta: string;
}

interface HomePageVisionProps {
  visionData: VisionData;
  onAction: (actionType: string, payload?: any) => void;
  id?: string;
}


export const HomePageVision: React.FC<HomePageVisionProps> = ({ visionData, onAction, id }) => {

  const listItemVariants = {
    // ... (same as before) ...
  };

  return (
    <section id={id} className="bg-white py-16 md:py-24">
      <div className="container mx-auto px-4">
        <div className="grid grid-cols-1 md:grid-cols-2 gap-x-12 gap-y-10 items-center">
          
          {/* Left Column: Visual */}
          {/* --- REPLACED PLACEHOLDER WITH NEW COMPONENT --- */}
          <ConsciousNetworkVisual />

          {/* Right Column: Text Content */}
          <motion.div
            initial={{ opacity: 0, x: 30 }}
            whileInView={{ opacity: 1, x: 0 }}
            viewport={{ once: true, amount: 0.3 }}
            transition={{ duration: 0.7, ease: [0.25, 1, 0.5, 1], delay: 0.2 }} // Added delay to animate after visual
          >
            <h2 className="text-3xl md:text-4xl font-bold text-gray-900 leading-tight">
              {visionData.headline}
            </h2>
            <p className="mt-4 text-lg text-slate-600">
              {visionData.intro}
            </p>
            <ul className="mt-6 space-y-3">
              {[visionData.point1, visionData.point2, visionData.point3].map((point, index) => (
                <motion.li
                  key={index}
                  custom={index}
                  variants={listItemVariants}
                  initial="hidden"
                  whileInView="visible"
                  viewport={{ once: true, amount: 0.8 }}
                  className="flex items-center gap-3"
                >
                  <Check size={20} className="text-emerald-500 flex-shrink-0" />
                  <span className="text-slate-700 font-medium">{point}</span>
                </motion.li>
              ))}
            </ul>
            <div className="mt-8">
              <Button
                text={visionData.cta}
                variant="secondary"
                size="lg"
                icon={<ArrowRight size={18} />}
                iconPosition="right"
                onClick={() => onAction('NAVIGATE_TO_PAGE', { path: '/vision' })}
              />
            </div>
          </motion.div>
        </div>
      </div>
    </section>
  );
};

